"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MEDICATION_CODE_PATTERN () {
        return _medication.MEDICATION_CODE_PATTERN;
    },
    get MEDICATION_FORMS () {
        return _medication.MEDICATION_FORMS;
    },
    get MedicationCodeSchema () {
        return _medication.MedicationCodeSchema;
    },
    get MedicationFormSchema () {
        return _medication.MedicationFormSchema;
    },
    get MedicationSearchItemSchema () {
        return _medicationsearch.MedicationSearchItemSchema;
    },
    get MedicationSearchRequestSchema () {
        return _medicationsearch.MedicationSearchRequestSchema;
    },
    get MedicationSearchResponseSchema () {
        return _medicationsearch.MedicationSearchResponseSchema;
    },
    get PRESCRIPTION_FREQUENCIES () {
        return _prescriptionfrequency.PRESCRIPTION_FREQUENCIES;
    },
    get PRESCRIPTION_FREQUENCY_KEYS () {
        return _prescriptionfrequency.PRESCRIPTION_FREQUENCY_KEYS;
    },
    get PrescriptionFrequencySchema () {
        return _prescriptionfrequency.PrescriptionFrequencySchema;
    },
    get SOLID_MEDICATION_FORMS () {
        return _medication.SOLID_MEDICATION_FORMS;
    }
});
const _medication = require("./medication");
const _prescriptionfrequency = require("./prescription-frequency");
const _medicationsearch = require("./medication-search");
